import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivableComment.Delete.IRequest;
type Response = Api.Finance.AccountReceivableComment.Delete.IResponse;
type Headers = Api.Finance.AccountReceivableComment.Delete.IHeaders;
const url = '/api/Finance/AccountReceivableComment/:id';
export default async function accountReceivableCommentDeleteApi({ id }: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}

